"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const backendImport_1 = require("@front/backendImport");
exports.default = backendImport_1.ONBOARDING;
